import { render, staticRenderFns } from "./venue-event.datacard.vue?vue&type=template&id=cff9e31e&scoped=true&"
import script from "./venue-event.datacard.vue?vue&type=script&lang=js&"
export * from "./venue-event.datacard.vue?vue&type=script&lang=js&"
import style0 from "./venue-event.datacard.vue?vue&type=style&index=0&id=cff9e31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff9e31e",
  null
  
)

export default component.exports